import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { ContactCampaignsApiInterface } from 'modules/contacts/contact-page/types/contact-campaigns-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import { ContactId } from '../../types/contact-interface'

interface UseContactCampaignsInterface extends SwrPaginationInterface {
  contactId: ContactId
}

export function useContactCampaigns({
  limit,
  pagination,
  contactId,
}: UseContactCampaignsInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactCampaignsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: contactCampaigns, mutate } = useControlledSwr(
    () => [
      `${CONTACT_API}/contacts/${contactId}/campaigns?${getPaginationQueryString({
        limit,
        pagination,
      })}`,
      RequestModuleEnum.Campaign,
      RequestModuleEnum.CampaignStep,
    ],
    fetcher,
    undefined,
    !!user,
  )

  return { contactCampaigns, mutate }
}
